import {
  ComponentPropsWithoutRef,
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import { multibox as formMultibox } from '../../form/field/multibox-input';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;
type FormMultiboxProps = ComponentPropsWithoutRef<typeof formMultibox>;

type Props = FormMultiboxProps;

export const multibox: FR<HTMLDivElement, Props> = forwardRef((props, ref) => {
  const FormMultibox = formMultibox;

  return <FormMultibox {...props} ref={ref} />;
});

multibox.displayName = 'SiloReal-Filter-Field-Multibox';
